import React from "react";

export function YoutubeColored({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44.9998 35.3125C44.5832 37.5 42.8123 39.1667 40.6248 39.4792C37.1873 40 31.4582 40.625 24.9998 40.625C18.6457 40.625 12.9165 40 9.37484 39.4792C7.18734 39.1667 5.4165 37.5 4.99984 35.3125C4.58317 32.9167 4.1665 29.375 4.1665 25C4.1665 20.625 4.58317 17.0833 4.99984 14.6875C5.4165 12.5 7.18734 10.8333 9.37484 10.5208C12.8123 10 18.5415 9.375 24.9998 9.375C31.4582 9.375 37.0832 10 40.6248 10.5208C42.8123 10.8333 44.5832 12.5 44.9998 14.6875C45.4165 17.0833 45.9373 20.625 45.9373 25C45.8332 29.375 45.4165 32.9167 44.9998 35.3125Z"
        fill="#FF3D00"
      />
      <path
        d="M20.8335 32.2916V17.7083L33.3335 24.9999L20.8335 32.2916Z"
        fill="white"
      />
    </svg>
  );
}
